// About.js
import React from 'react';
import { Typography, Grid } from '@mui/material';
import NewsReleaseCard from './NewsReleaseCard';
import RLCImage from '../rlc_logo_new_color_200x200.png';
import AmityImage from '../amity.jpg';

const datax = {
  0: {
    'title': 'Republican Liberty Caucus of Virginia Announces Formation, Officers, and Mission',
    'date': 'August 12, 2025',
    'summary': 'New Chairwoman Amity Dolby sets sights on future member recruitment, political endorsements, and principled messaging.',
    'image': RLCImage,
    'link': 'https://www.einpresswire.com/article/838571496/republican-liberty-caucus-of-virginia-announces-formation-officers-and-mission',
    'profile': AmityImage,
    'content': `RICHMOND, VA, UNITED STATES, August 12, 2025 /EINPresswire.com/ -- The newly formed Republican Liberty Caucus (RLC) of Virginia has announced it has held its inaugural membership meeting and completed filing articles of incorporation with the RLC national board and with the Commonwealth of Virginia. The newest chapter of the RLC elected a full slate of officers and approved organizational bylaws.
    
    Amity Dolby, serving as the RLC of Virginia’s first chairperson, emphasized the group’s mission. "Our team is excited to welcome liberty-minded Virginians as members, to vet liberty-minded candidates for endorsement, and to spread awareness of the principles of liberty throughout the commonwealth,” said Dolby.
    
    Other officers include Donna Grebas as vice chair, Corey Fauconier as secretary, and Jeff Kleb as at-large board member.
    
    Republican Liberty Caucus national chair John Dennis added, "Congratulations to the RLC of Virginia! We have enjoyed working together already and look forward to collaborating to build a big tent in Virginia."
    
    Several of the group's members were recruited by the 2024 Libertarian Party vice-presidential nominee, Mike ter Maat, who joined the Republican Liberty Caucus in June along with dozens of former campaign staffers and liberty-minded Republicans (see press release of June 10, 2025). Said ter Maat, "It has been rewarding to see long-time Republicans and new Republicans come together to advance the cause of liberty in Virginia.”
    
    ABOUT THE REPUBLICAN LIBERTY CAUCUS
The RLC is a grassroots organization working within the Republican Party to advance the principles of individual liberty, limited government, and free markets.

MEDIA INQUIRIES AND INTERVIEW REQUESTS
            Corey Fauconier`
  },
  1: {
    'title': 'Republican Liberty Caucus of Virginia endorses Andy Pittman for Virginia House of Delegates District 94',
    'date': 'November 1, 2025',
    'summary': 'RLC Endorsement Announcement: Andy Pittman for Virginia House of Delegates District 94',
    'image': RLCImage,
    'link': '',
    'profile': AmityImage,
    'content': `Republican Liberty Caucus of Virginia endorses Andy Pittman for Virginia House of Delegates District 94. Andy Pittman believes the government governs best when it governs the least. 
    
    As a constitutionally centered attorney, he will work hard to safeguard our liberties and freedoms and defend our rights under the U.S. and Virginia constitutions. Andy will work to reduce our taxes and cut excessive regulations that stifle the free market and inhibit economic growth. He understands that when you have to pay tribute to the government every year for the privilege of owning your vehicle, you don’t truly own it, the government does. Andy agrees that it’s long past time to get rid of this onerous tax once and for all. 
    
    Andy will also work to limit the Virginia National Guard’s involvement in foreign military conflicts through efforts such as Defend the Guard legislation. As your Delegate, Andy will fight for you and put you first and will always put People Over Politics.`
  },
}

const NewsReleases = () => {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        News Releases
      </Typography>
      <Grid container spacing={2}>
        {Object.keys(datax).map((item, index) => (
          <Grid item key={item} xs={12} md={6}>
            <NewsReleaseCard item={datax[item]} />
          </Grid>
        ))}
      </Grid>
      <br />
      <br />
    </div>
  );
};

export default NewsReleases;